import { formatProjectTypeLabel } from '@kaiizen/kai-presenters';
import { useAllOrgSettings } from '@kaiizen/kai-pro-api-react-state';
import { useCallback, useMemo } from 'react';

import {
  getOrgSettingsProjectTypeOptions,
  getProjectTypeLabelEntries,
  type ProjectTypeOption,
  type ProjectTypesRecord,
} from './projectTypeLib';

export const useProjectTypes = () => {
  const { allOrgSettings } = useAllOrgSettings();

  const projectTypeLabels = useMemo(
    () =>
      getProjectTypeLabelEntries(
        allOrgSettings?.projectSettings?.types as ProjectTypesRecord | undefined,
      ),
    [allOrgSettings?.projectSettings?.types],
  );

  const getProjectTypeLabel = useCallback(
    (projectType?: string | null) => {
      if (!projectType) return null;
      return projectTypeLabels[projectType] || formatProjectTypeLabel(projectType);
    },
    [projectTypeLabels],
  );

  const projectTypeOptions = useMemo<ProjectTypeOption[]>(
    () =>
      getOrgSettingsProjectTypeOptions(
        allOrgSettings?.projectSettings?.types as ProjectTypesRecord | undefined,
      ),
    [allOrgSettings?.projectSettings?.types],
  );

  const getProjectTypeOptions = useCallback(
    (currentProjectType?: string | null) => {
      if (
        !currentProjectType
        || projectTypeOptions.some(option => option.value === currentProjectType)
      ) {
        return projectTypeOptions;
      }

      return getOrgSettingsProjectTypeOptions(
        allOrgSettings?.projectSettings?.types as ProjectTypesRecord | undefined,
        currentProjectType,
      );
    },
    [allOrgSettings?.projectSettings?.types, projectTypeOptions],
  );

  return {
    projectTypeOptions,
    projectTypeLabels,
    getProjectTypeLabel,
    getProjectTypeOptions,
  };
};
